/* eslint-disable no-param-reassign */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/prop-types */
import React from "react";
import { Card, CardBody, Badge } from "reactstrap";
import { NavLink } from "react-router-dom";

import { Colxx } from "../common/CustomBootstrap";
import IntlMessages from "../../helpers/IntlMessages";

const RequestListItem = ({ item, handleCheckChange, isSelected, match }) => {
  let alacarteRequests;
  if (item.service_type === "ALACARTE_RESTAURANT_RESERVATION") {
    const c211 = item.custom_fields_values.find(p => p.id === "211")?.value;
    const c212 = item.custom_fields_values.find(p => p.id === "212")?.value;
    const c213 = item.custom_fields_values.find(p => p.id === "213")?.value;

    let childCount = c212 ? JSON.parse(c212)?.children_count : 0;
    childCount = childCount === "" ? 0 : childCount;
    const personCount = c212 ? JSON.parse(c212).people_count : 0;

    const NameRoomAndMainCourses = c213 ? JSON.parse(c213) : [];
    const restaurantTimeSlot = c211 ? JSON.parse(c211).restaurant_time_slot : undefined;
    if (typeof item.staff_summary === "object") {
      [item.staff_summary] = Object.values(item.staff_summary);
    }
    alacarteRequests = (
      <div className="pt-0 mt-0">
        <div className="d-flex flex-grow-1 min-width-zero">
          <CardBody
            className="align-self-center d-flex flex-column flex-md-row 
            justify-content-between min-width-zero align-items-md-center"
          >
            <div className="w-25 w-xs-100">
              <div className="badge badge-outline-dark" style={{ fontSize: "15px" }}>
                <div className="float-right">
                  <p className="mb-1">
                    <IntlMessages id="alacarte.person" />: {personCount}
                  </p>
                  <p className="mb-0">
                    <IntlMessages id="alacarte.child" />: {childCount}
                  </p>
                </div>
              </div>
            </div>
            <div className="w-40 w-xs-100 text-one">
              {NameRoomAndMainCourses.length > 0 ? (
                <div>
                  {NameRoomAndMainCourses.map((res, index) => {
                    return (
                      <div key={index}>
                        <span>{res.name}</span>
                        <span>{res.main_course_name ? `, ${res.main_course_name}` : ""}</span>
                        {res.room_number || res.room ? ", " : ""}
                        <span>
                          <span className="text-muted">
                            <IntlMessages id="request.room" />
                          </span>{" "}
                          {res.room_number || res.room}
                        </span>
                      </div>
                    );
                  })}
                </div>
              ) : (
                ""
              )}
              <hr style={{ marginTop: 5, marginBottom: 5 }} />
              <span>{JSON.parse(item.custom_fields_values[0].value).restaurant_name},</span>
              <br />
              <span>{restaurantTimeSlot ? `${restaurantTimeSlot}` : `${item.due_at_date}`}</span>
            </div>
            <p className="mb-1 text-muted w-20 w-xs-100 text-one" style={{ marginRight: "10px" }} />
          </CardBody>
        </div>
      </div>
    );
  }
  return (
    <Colxx xxs="12">
      <NavLink to={`${match.url}/${item.id}`} id={`toggler${item.id}`}>
        <Card className="card d-flex mb-2" style={{ overflow: "hidden" }}>
          <div className="d-flex">
            <div
              className={`${
                item.status === "CLOSED"
                  ? "request_color col-1"
                  : item.status === "OPEN"
                  ? "request_color open col-1"
                  : item.status === "CANCELED"
                  ? "request_color col-1"
                  : "request_color pending col-1"
              }`}
            />
            <div className="request-main">
              <div className="d-flex flex-grow-1 min-width-zero">
                <CardBody
                  className="align-self-center d-flex flex-column flex-md-row 
          justify-content-between min-width-zero align-items-md-center"
                >
                  <span className="align-middle text-one d-inline-block w-25 w-xs-100">
                    {item.service && item.service.name ? item.service.name : ""}
                  </span>

                  {item.is_staff !== "true" ? (
                    <p className="mb-1 w-40 w-xs-100 text-one">
                      <span className="text-muted">{item.fullName}</span>
                      {item.room_number || item.req_room_number ? ", " : ""}
                      {item.req_room_number ? (
                        <span>
                          <span className="text-muted">
                            <IntlMessages id="request.room" />
                          </span>{" "}
                          {item.req_room_number}
                        </span>
                      ) : item.room_number ? (
                        <span>
                          <span className="text-muted">
                            <IntlMessages id="request.room" />
                          </span>{" "}
                          {item.room_number}
                        </span>
                      ) : (
                        ""
                      )}
                    </p>
                  ) : (
                    <div className="w-40 w-xs-100">
                      <h4>
                        <Badge color="light" pill>
                          <IntlMessages id="alacarte.request_owner_staff" />
                        </Badge>
                      </h4>
                    </div>
                  )}
                  <p className="mb-1 text-muted w-20 w-xs-100 text-one" style={{ marginRight: "10px" }}>
                    {item.updated_at_date}
                  </p>
                </CardBody>
              </div>
              <div
                className="card-body pt-1 align-self-center d-flex flex-column flex-md-row 
                justify-content-between min-width-zero align-items-md-center "
              >
                <div>
                  {item.is_staff !== "true" ? (
                    <p className="mb-0 text-one w-100 w-xs-100">
                      <span className="text-muted">
                        <IntlMessages id="request.details" />:
                      </span>{" "}
                      {<span dangerouslySetInnerHTML={{ __html: item.staff_summary }} />}
                    </p>
                  ) : (
                    ""
                  )}
                </div>
                <div className="w-20">
                  <div className="mt-1 mb-0 p-1 text-one w-75 w-xs-100">
                    {item.booking && item.booking.butler && (
                      <div className="d-flex">
                        <h6 className="text-muted">
                          Butler: <span className="text-span"> {item.booking.butler}</span>
                        </h6>
                      </div>
                    )}
                  </div>

                  {item.payable === "true" ? (
                    <div className="mb-1">
                      <div className="badge badge-outline-success" style={{ fontSize: "15px" }}>
                        <div className="float-left">
                          <i className="simple-icon-credit-card" style={{ fontSize: "25px" }} />
                        </div>
                        <div className="float-right mt-1 ml-1">
                          <IntlMessages id="request.payable" />
                        </div>
                      </div>
                    </div>
                  ) : (
                    ""
                  )}
                  {item.status && item.status === "CANCELED" ? (
                    <div className="badge badge-danger" style={{ fontSize: "20px" }}>
                      <span className="text-one">
                        <IntlMessages id="request.list_status_canceled" />
                      </span>
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              </div>

              {alacarteRequests}
            </div>
          </div>
        </Card>
      </NavLink>
    </Colxx>
  );
};

export default React.memo(RequestListItem);
